import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login'
import Home from '@/views/Home'
import Welcome from '@/views/Welcome'
import BigScreen from '@/views/bigScreen'

import Rolemanagement from '../views/userManagement/rolemanagement.vue' // 角色管理
import AddRole from '../views/userManagement/addrole.vue'// 新增角色
import ReviseRole from '../views/userManagement/reviserole.vue'// 修改角色

import EnterpriseUser from '../views/userManagement/enterpriseuser.vue' // 用户 企业
import AddEnterprise from '../views/userManagement/addEnterprise.vue' // 用户新增 企业
import ReviseEnterpriseuser from '../views/userManagement/reviseEnterpriseuser.vue' // 用户 修改企业用户
import DetailEnterprise from '../views/userManagement/detailEnterprise.vue'// 用户详情
import UserWallet from '../views/userManagement/userWallet.vue'// 用户钱包

import IsenterpriseUser from '../views/userManagement/isenterpriseUser.vue' // 用户 非企业
import AddIsenterprise from '../views/userManagement/addIsenterprise.vue' // 新增用户 非企业
import ReviseIsnterprise from '../views/userManagement/reviseIsenterprise.vue' // 修改用户 非企业
import DetailIsenterprise from '../views/userManagement/detailIsenterprise.vue' // 详情用户 非企业
import IsUserWallet from '../views/userManagement/isuserWallet.vue'// 用户钱包 非企业

import Administrators from '../views/userManagement/administrators.vue' // 用户 管理员
import AddAdministrators from '../views/userManagement/addAdministrators.vue' // 用户 新增管理员
import ReviseAdministrators from '../views/userManagement/reviseAdministrators.vue' // 用户 修改管理员

import TagManager from '../views/discount/TagManager' // 标签管理
import AddTag from '../views/discount/addTag' // 新增标签
import ModifyUserTag from '../views/discount/modifyUserTag' // 修改用户标签
import ModifySystemTag from '../views/discount/modifySystemTag' // 修改系统标签

import SubsidyManagement from '../views/userManagement/subsidyManagement.vue' // 补贴管理
import SubsidyEdit from '../views/userManagement/subsidyEdit.vue' // 补贴操作

import userLevel from '../views/equityManagement/userLevel.vue' // 用户等级
import addUserLevel from '../views/equityManagement/addUserLevel.vue' // 用户等级 新增
import userEquity from '../views/equityManagement/userEquity.vue' // 用户权益
import addUserEquity from '../views/equityManagement/editUserEquity.vue' // 用户权益 新增
import reviseUserEquity from '../views/equityManagement/editUserEquity.vue' // 用户权益 修改

import PlantManagement from '../views/plantManagement/plantManagement.vue' // 自营电站管理
import AddPlant from '../views/plantManagement/addPlant.vue' // 新增电站
import PlantDetail from '../views/plantManagement/plantDetail.vue' // 电站详情
import PlantRobot from '../views/plantManagement/plantRobot.vue' // 周边设备
import RevisePlant from '../views/plantManagement/revisePlant.vue' // 电站详情
import PileManagement from '../views/plantManagement/pilemanagement.vue' // 自营电桩管理
import AddPile from '../views/plantManagement/addPile.vue' // 新增电桩
import ChargingPile from '../views/plantManagement/chargingPile.vue' // 修改电桩
import PileDetail from '../views/plantManagement/pileDetail.vue' // 充电枪详情
import InterconnectedStation from '../views/plantManagement/InterconnectedStation.vue' // 互联互通电站
import InterConStationDetail from '../views/plantManagement/InterConStationDetail.vue'// 互联互通电站详情
import ReviseInterConStation from '../views/plantManagement/reviseInterConStation.vue'// 互联互通电站修改
import InterConPileDetail from '../views/plantManagement/InterConPileDetail.vue'// 互联互通电桩详情

import WhiteList from '../views/plantManagement/whiteList.vue' // 白名单
import AddWhiteList from '../views/plantManagement/addWhiteList.vue' // 新增白名单
import ReviseWhiteList from '../views/plantManagement/reviseWhiteList.vue' // 新增白名单
import WhiteListDetail from '../views/plantManagement/whiteListDetail.vue' // 白名单详情

import FlowScheme from '../views/flowScheme/flowScheme.vue' // 流量方案 增值服务
import AddFlowScheme from '../views/flowScheme/addFlowScheme.vue'// 新增流量方案
import FlowSchemeDetail from '../views/flowScheme/flowSchemeDetail.vue'// 流量方案详情
import ReviseFlowScheme from '../views/flowScheme/reviseFlowScheme.vue'// 流量方案修改
import EntranceScheme from '../views/flowScheme/entranceScheme.vue'// 入口方案
import AddEntrance from '../views/flowScheme/addEntrance.vue'// 新增入口方案
import EntranceDetail from '../views/flowScheme/entranceDetail.vue'// 入口方案详情
import ReviseEntrance from '../views/flowScheme/reviseEntrance.vue'// 入口方案修改


import AddOperatormanagement from '../views/organManagement/addOperatormanagement.vue' // 新增 运营商
import ModifyOperatormanagement from '../views/organManagement/modifyOperatormanagement.vue' // 运营商详情
import OperatorManagement from '../views/organManagement/operatormanagement.vue' // 企业管理
import OperatorWallet from '../views/organManagement/operatorWallet.vue' // 企业钱包
import OperatorDetail from '../views/organManagement/operatorDetail.vue' // 详情

import GateManagement from '../views/systemManagement/gatemanagement.vue' // 道闸管理
import AddGate from '../views/systemManagement/addGate.vue' // 道闸管理新增
import GateDetail from '../views/systemManagement/gateDetail.vue' // 道闸详情
import ReviseGate from '../views/systemManagement/reviseGate.vue' // 修改道闸
import SecretKeymanagement from '../views/systemManagement/secretKeymanagement.vue' // 互联互通密钥
import AddSecretKey from '../views/systemManagement/addSecretKey.vue' // 新增密钥
import SecretKeyDetail from '../views/systemManagement/secretKeyDetail.vue' // 密钥详情
import ReviseSecretKey from '../views/systemManagement/reviseSecretKey.vue' // 密钥修改

import SystemSetting from '../views/systemManagement/systemSetting.vue' // 系统设置
import SmsSettings from '../views/systemManagement/smsSettings.vue' // 短信设置
import LogManagement from '../views/systemManagement/LogManagement.vue' // 电桩报文
import LogDetail from '../views/systemManagement/logDetail.vue' // 报文详情
import LogOperation from '../views/systemManagement/logOperation.vue' // 操作日志
// import AppManagement from '../views/systemManagement/appManagement.vue' // APP版本管理
import StationBrand from '../views/systemManagement/stationBrand.vue' // 电桩品牌管理
import StationModel from '../views/systemManagement/stationModel.vue' // 电桩型号管理
import StationModelAdd from '../views/systemManagement/stationModelAdd.vue' // 电桩型号管理新增
import StationModelModify from '../views/systemManagement/stationModelModify.vue' // 电桩型号管理修改

import FirmwareVersion from '../views/systemManagement/firmwareVersion.vue' // 固件版本管理
import EditVersion from '../views/systemManagement/editVersion.vue' // 固件版本新增修改

import NearRobot from '../views/systemManagement/nearRobot.vue'
import NearModify from '../views/systemManagement/nearModify.vue'

import OrderManagement from '../views/orderManagement/ordermanagement.vue' // 订单管理  用户实时订单
import OrderStationmanagement from '../views/orderManagement/orderStationmanagement.vue' // 电站实时订单
import Historymanagement from '../views/orderManagement/historymanagement.vue' // 用户历史订单
import HistoryStationmanagement from '../views/orderManagement/historyStationmanagement.vue' // 电站历史订单
import OrderDetail from '../views/orderManagement/orderDetail.vue' // 实时订单详情
import HistoryDetail from '../views/orderManagement/historyDetail.vue' // 历史订单详情
import PendingOrders from '../views/orderManagement/pendingOrders.vue' // 待处理订单
import PendingDetail from '../views/orderManagement/pendingDetail.vue' // 待处理订单详情
import ProcessingPending from '../views/orderManagement/processingPending.vue' // 处理订单
import occupyDetail from '../views/orderManagement/occupyDetail.vue' // 占用记录详情

import RegistrationActivities from '../views/activityManagement/registrationActivities.vue' // 注册活动
import RegistrationAdd from '../views/activityManagement/registrationAdd.vue' // 注册活动新增
import RegistrationModify from '../views/activityManagement/registrationModify.vue' // 注册活动修改
import RechargeActivities from '../views/activityManagement/RechargeActivities.vue' // 充值活动
import RechargeAdd from '../views/activityManagement/RechargeAdd.vue' // 充值活动新增
import RechargeModify from '../views/activityManagement/RechargeModify.vue' // 充值活动修改
import RechargeDetail from '../views/activityManagement/rechargeDetail.vue' // 充值活动详情
import SingleConsumption from '../views/activityManagement/singleConsumption.vue' // 单次消费活动
import SingleAdd from '../views/activityManagement/singleAdd.vue' // 单次消费活动新增
import SingleModify from '../views/activityManagement/singleModify.vue' // 单次消费活动修改
import SingleDetail from '../views/activityManagement/singleDetail.vue' // 单次消费活动详情

import firstCharge from '../views/activityManagement/firstCharge.vue' // 首次充电活动
import firstAdd from '../views/activityManagement/firstAdd.vue' // 首次充电活动新增
import firstModify from '../views/activityManagement/firstModify.vue' // 首次充电活动修改
import firstDetail from '../views/activityManagement/firstDetail.vue' // 首次充电活动修改

import groupCharge from '../views/activityManagement/groupCharge.vue' // 组团充电活动
import groupAdd from '../views/activityManagement/groupAdd.vue' // 组团充电活动新增
import groupModify from '../views/activityManagement/groupModify.vue' // 组团充电活动修改
import groupDetail from '../views/activityManagement/groupDetail.vue' // 组团充电活动修改
import CumulativeConsumption from '../views/activityManagement/cumulativeConsumption.vue' // 累计消费活动
import CumulativeAdd from '../views/activityManagement/cumulativeAdd.vue' // 累计消费活动新增
import CumulativeModify from '../views/activityManagement/cumulativeModify.vue' // 累计消费活动修改
import CumulativeDetail from '../views/activityManagement/cumulativeDetail.vue' // 累计消费活动详情
import ShareActivity from '../views/activityManagement/shareActivity.vue' // 分享活动
import ShareAdd from '../views/activityManagement/shareAdd.vue' // 分享活动新增
import ShareModify from '../views/activityManagement/shareModify.vue' // 分享活动修改
import ShareDetail from '../views/activityManagement/shareDetail.vue' // 分享活动详情

import scanGet from '../views/activityManagement/scanGet.vue' // 扫码领券活动
import scanAdd from '../views/activityManagement/scanAdd.vue' // 扫码领券活动新增
import scanModify from '../views/activityManagement/scanModify.vue' // 扫码领券活动修改
import scanDetail from '../views/activityManagement/scanDetail.vue' // 扫码领券活动详情
import PileSafetyAlarm from '../views/alarmManagement/pileSafetyAlarm.vue' // 电桩安全告警
import PileSafetyAlarmDetail from '../views/alarmManagement/pileSafetyAlarmDetail.vue' // 电桩安全告警详情
import PileOffLineAlarmDetail from '../views/alarmManagement/pileOffLineAlarmDetail.vue' // 电桩离线告警详情
import PileFaultAlarmDetail from '../views/alarmManagement/pileFaultAlarmDetail.vue' // 电桩故障告警详情
import VehicleAlarm from '../views/alarmManagement/vehicleAlarm.vue' // 车辆告警
import VehicleAlarmDetail from '../views/alarmManagement/vehicleAlarmDetail.vue' // 车辆告警详情
import NegativeValueAlarm from '../views/alarmManagement/negativeValueAlarm.vue' // 账户负值告警
import StationAlarmSetting from '../views/alarmManagement/stationAlarmSetting.vue' // 告警设置
import AddAlarmSetting from '../views/alarmManagement/addAlarmSetting.vue' // 新增告警设置
import AlarmSettingDetail from '../views/alarmManagement/alarmSettingDetail.vue' // 告警设置详情
import ReviseAlarmSetting from '../views/alarmManagement/reviseAlarmSetting.vue' // 修改告警设置
import GroupManagement from '../views/alarmManagement/groupManagement.vue' // 告警通知组管理
import AlarmNotificationRecord from '../views/alarmManagement/alarmNotificationRecord.vue' // 告警通知记录
import KeshidaRecord from '../views/alarmManagement/keshidaRecord.vue' // 告警通知记录
import AddGroupManagement from '../views/alarmManagement/addGroupManagement.vue' // 新增告警通知组管理
import ReviseGroup from '../views/alarmManagement/reviseGroup.vue' // 修改告警通知组
import GroupManagementDetail from '../views/alarmManagement/groupManagementDetail.vue' // 告警通知组管理详情

import StationTotal from '../views/statistics/stationTotal.vue'// 电站统计 统计中心
import PileTotal from '../views/statistics/pileTotal.vue'// 终端统计
import OrganTotal from '../views/statistics/organTotal.vue' // 车辆机构统计
import UserTotal from '../views/statistics/userTotal.vue' // 用户统计
import TimeUserTotal from '../views/statistics/timeUserTotal.vue' // 时期用户统计
import TimeStationTotal from '../views/statistics/timeStationTotal.vue' // 时期电站统计
import PileUse from '../views/statistics/pileUse.vue' // 电桩使用统计
import PileFault from '../views/statistics/pileFault.vue' // 电桩故障统计
import PileFaultList from '../views/statistics/pileFaultList' // 某个故障电桩列表

import InformManagement from '../views/informManagement/informmanagement.vue' // 通知管理
import AddInformManagement from '../views/informManagement/addInformManagement.vue' // 新增通知
import InformDetail from '../views/informManagement/informDetail.vue' // 通知详情
import ReviseInform from '../views/informManagement/reviseInform.vue' // 修改通知

import AdManagement from '../views/adManagement/admanagement.vue' // 广告管理
import AddAd from '../views/adManagement/addAd.vue' // 新增广告
import ReviseAd from '../views/adManagement/reviseAd.vue' // 修改广告

import Discount from '../views/discount/discount.vue' // 优惠方案
import CouponManager from '../views/discount/CouponManager' // 优惠券管理
import CouponManagerAdd from '../views/discount/couponManagerAdd' // 优惠券新增
import CouponDetail from '../views/discount/couponDetail' // 优惠券详情
import CouponIssuance from '../views/discount/couponIssuance' // 优惠券发放
import CouponIssuanceDetails from '../views/discount/couponIssuanceDetails' // 优惠券发放明细

import AddDiscount from '../views/discount/addDiscount.vue' // 新增优惠方案
import ReviseDiscount from '../views/discount/reviseDiscount.vue' // 修改优惠方案
import DiscountDetail from '../views/discount/discountDetail.vue' // 优惠方案详情
import ManualRelease from '../views/discount/manualRelease.vue' // 手动发放记录
import ManualReleaseDetail from '../views/discount/manualReleaseDetail.vue' // 手动发放记录详情
import ManualReleaseUpdate from '../views/discount/manualReleaseUpdate.vue' // 手动发放记录修改

import TicketManagement from '../views/ticketManagement/ticketmanagement.vue' // 票务管理
import moneyCount from '../views/ticketManagement/moneyCount.vue' // 分润汇总
import earnMoney from '../views/ticketManagement/earnMoney.vue' // 分润金额查看
import TicketModification from '../views/ticketManagement/ticketModification.vue' // 票务修改
import InvoiceApproval from '../views/ticketManagement/invoiceApproval.vue' // 开票审批
import InvoiceDetail from '../views/ticketManagement/invoiceDetail.vue' // 开票详情
import SummaryFinancial from '../views/ticketManagement/summaryFinancial.vue' // 财务概况
import OrderDetailSummary from '../views/ticketManagement/orderDetail.vue'// 财务明细中订单详情
import SummaryDetailFinancial from '../views/ticketManagement/summaryDetailFinancial.vue' // 运营商机构财务明细
import CarDetail from '../views/ticketManagement/carDetail.vue' // 车辆机构财务明细
import moneyDetail from '../views/ticketManagement/moneyDetail.vue' // 分润明细
import payDetail from '../views/ticketManagement/payDetail.vue' // 分润订单明细
import profitRecord from '../views/ticketManagement/profitRecord.vue' // 分润记录
import profitSettle from '../views/ticketManagement/profitSettle.vue' // 分润记录结算
import FlowDetail from '../views/ticketManagement/flowDetail.vue' // 流量方财务明细

import PlantComment from '../views/plantComment/plantcomment.vue'// 站点评论管理

import ChargingCard from '../views/chargingCard/chargingcard.vue'// 充电卡管理
import ChargingCardModify from '../views/chargingCard/chargingCardModify.vue'// 充电卡修改

// import MonitorView from '../views/monitorView/monitorView'

// 桩理财页面 end----

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/bigScreen',
      name: 'BigScreen',
      component: BigScreen
    },
    {
      path: '/Welcome',
      name: 'Home',
      component: Home,
      children: [
        {
          path: '',
          component: Welcome
        }
      ]
    },
    {
      path: '/userManagement',
      name: 'userManagement',
      meta: {
        title: 'userManagement',
        icon: 'iconfont icon-yonghuguanli',
        permission: 'user'
      },
      component: Home,
      children: [
        {
          path: 'enterpriseUser',
          name: 'qiyeyonghu',
          meta: {
            title: 'enterpriseUsers',
            icon: 'iconfont icon-qiyeyonghuguanli',
            permission: 'user.enterprise',
            show: 'true',

          },
          component: EnterpriseUser
        },
        {
          path: 'reviseEnterpriseuser',
          name: 'xiugaiqiyeyonghu',
          meta: {
            title: 'editEnterpriseUsers',
            icon: '',
            permission: 'user.enterprise.update',
            father:'enterpriseUsers'
          },
          component: ReviseEnterpriseuser
        },
        {
          path: 'addEnterprise',
          name: 'xinzengqiyeyonghu',
          meta: {
            title: 'addEnterpriseUsers',
            icon: '',
            permission: 'user.enterprise.add',
            father:'enterpriseUsers'
          },
          component: AddEnterprise
        },
        {
          path: 'detailEnterprise',
          name: 'yonghuxiangqing',
          meta: {
            title: 'userDetails',
            icon: '',
            permission: 'user.enterprise.details',
            father:'enterpriseUsers'
          },
          component: DetailEnterprise
        },
        {
          path: 'userWallet',
          name: 'yonghuqianbao',
          meta: {
            title: 'UserWallet',
            icon: '',
            permission: 'user.enterprise.wallet',
            father:'enterpriseUsers'
          },
          component: UserWallet
        },
        {
          path: 'isenterpriseUser',
          name: 'feiqiyeyonghu',
          meta: {
            title: 'isenterpriseUser',
            icon: 'iconfont icon-guanliyuan',
            permission: 'user.notenterprise',
            show: 'true'
          },
          component: IsenterpriseUser
        },
        {
          path: 'addIsenterprise',
          name: 'xinzengfeiqiye',
          meta: {
            title: 'addIsenterpriseUser',
            icon: '',
            permission: 'user.notenterprise.add',
            father:'isenterpriseUser'
          },
          component: AddIsenterprise
        },
        {
          path: 'reviseIsenterprise',
          name: 'xiugaifeiqiye',
          meta: {
            title: 'editIsenterpriseUser',
            permission: 'user.notenterprise.update',
            father:'isenterpriseUser'
          },
          component: ReviseIsnterprise
        },
        {
          path: 'detailIsenterprise',
          name: 'feiqiyexiangqing',
          meta: {
            title: 'userDetails2',
            permission: 'user.notenterprise.details',
            father:'isenterpriseUser'
          },
          component: DetailIsenterprise
        },
        {
          path: 'isuserWallet',
          name: 'yonghuqianbao',
          meta: {
            title: 'UserWallet2',
            permission: 'user.notenterprise.wallet',
            father:'isenterpriseUser'
          },
          component: IsUserWallet
        },
        {
          path: 'TagManager',
          name: 'biaoqianguanli',
          meta: {
            title: 'labelManagement',
            icon: 'iconfont icon-youhui',
            permission: 'user.tag',
            show: 'true'
          },
          component: TagManager
        },
        {
          path: 'addTag',
          name: 'xinzengbiaoqian',
          meta: {
            title: 'addTag',
            icon: 'iconfont icon-youhui',
            permission: 'user.tag.add',
            father:'labelManagement'
          },
          component: AddTag
        },
        {
          path: 'modifyUserTag',
          name: 'xiugaiyonghubiaoqian',
          meta: {
            title: 'modifyUserTag',
            icon: 'iconfont icon-youhui',
            permission: 'user.tag.update',
            father:'labelManagement'
          },
          component: ModifyUserTag
        },
        {
          path: 'modifySystemTag',
          name: 'xiugaiyonghubiaoqian',
          meta: {
            title: 'modifySystemTag',
            icon: 'iconfont icon-youhui',
            permission: 'user.tag.update',
            father:'labelManagement'
          },
          component: ModifySystemTag
        },
        {
          path: 'subsidyManagement',
          name: 'butieguanli',
          meta: {
            title: 'subsidyManagement',
            icon: 'iconfont icon-youhui',
            permission: 'subsidy',
            show: 'true'
          },
          component: SubsidyManagement
        },
        {
          path: 'addSubsidy',
          name: 'xinzengbutie',
          meta: {
            title: 'addSubsidy',
            icon: 'iconfont icon-youhui',
            permission: 'subsidy.add',
            father:'subsidyManagement'
          },
          component: SubsidyEdit
        },
        {
          path: 'modifySubsidy',
          name: 'xiugaibutie',
          meta: {
            title: 'modifySubsidy',
            icon: 'iconfont icon-youhui',
            permission: 'subsidy.update',
            father:'subsidyManagement'
          },
          component: SubsidyEdit
        },
        {
          path: 'detailSubsidy',
          name: 'butiexiangqing',
          meta: {
            title: 'detailSubsidy',
            icon: 'iconfont icon-youhui',
            permission: 'subsidy.detail',
            father:'subsidyManagement'
          },
          component: SubsidyEdit
        }
      ]
    },
    {
      path: '/equityManagement',
      name: 'quanyiguanli',
      meta: {
        title: 'equityManagement',
        icon: 'iconfont icon-fuwufei',
        permission: 'equityManagement'
      },
      component: Home,
      children: [
        {
          path: 'userLevel',
          name: 'yonghudengji',
          meta: {
            title: 'userLevel',
            icon: 'iconfont icon-qiyeyonghuguanli',
            permission: 'equityManagement.userRating',
            show: 'true'
          },
          component: userLevel
        },
        {
          path: 'addUserLevel',
          name: 'xinzengyonghudengji',
          meta: {
            title: 'addUserLevel',
            icon: '',
            permission: 'equityManagement.userRating.add',
            father:'userLevel'
          },
          component: addUserLevel
        },
        {
          path: 'userEquity',
          name: 'yonghuquanyi',
          meta: {
            title: 'userEquity',
            icon: 'iconfont icon-shishoufeiyong',
            permission: 'equityManagement.userEquity',
            show: 'true',
          },
          component: userEquity
        },
        {
          path: 'addUserEquity',
          name: 'xinzengyonghuquanyi',
          meta: {
            title: 'addUserEquity',
            permission: 'equityManagement.userEquity.add',
            father:'userEquity'
          },
          component: addUserEquity
        },
        {
          path: 'reviseUserEquity',
          name: 'xiugaiyonghuquanyi',
          meta: {
            title: 'reviseUserEquity',
            permission: 'equityManagement.userEquity.update',
            father:'userEquity'
          },
          component: reviseUserEquity
        }
      ]
    },
    {
      path: '/powerManagement',
      name: 'quanxianguanli',
      meta: {
        title: 'authorityManagement',
        icon: 'iconfont icon-quanxianguanli',
        permission: 'power'
      },
      component: Home,
      children: [
        {
          path: 'administrators',
          name: 'guanliyuanyonghu',
          meta: {
            title: 'administrators',
            icon: 'iconfont icon-guanliyuan',
            permission: 'power.Administrator',
            show: 'true'
          },
          component: Administrators
        },
        {
          path: 'addAdministrators',
          name: 'xinzengguanliyuan',
          meta: {
            title: 'addAdministrators',
            icon: '',
            permission: 'power.Administrator.add',
            father:'administrators'
          },
          component: AddAdministrators
        },
        {
          path: 'reviseAdministrators',
          name: 'xiugaiguanliyuan',
          meta: {
            title: 'editAdministrators',
            icon: '',
            permission: 'power.Administrator.update',
            father:'administrators'
          },
          component: ReviseAdministrators
        },
        {
          path: 'rolemanagement',
          name: 'jueseguanli',
          meta: {
            title: 'roleManagement',
            icon: 'iconfont icon-quanxianguanli',
            permission: 'power.role',
            show: 'true'
          },
          component: Rolemanagement
        },
        {
          path: 'addrole',
          path: 'addrole',
          name: 'xinzengjuese',
          meta: {
            title: 'addRole',
            permission: 'power.role.add',
            father:'roleManagement'
          },
          component: AddRole
        },
        {
          path: 'reviserole',
          name: 'xiugaijuese',
          meta: {
            title: 'editRole',
            permission: 'power.role.update',
            father:'roleManagement'
          },
          component: ReviseRole
        }
      ]
    },
    {
      path: '/plantManagement',
      name: 'plantManagement',
      meta: {
        title: 'stationManagement',
        icon: 'iconfont icon-chongdianzhuang',
        permission: 'pile'
      },
      component: Home,
      children: [
        {
          path: 'plantManagement',
          name: 'dianzhanguanli',
          meta: {
            title: 'powerStationManagement',
            icon: 'iconfont icon-dianzhangaikuang',
            permission: 'pile.station',
            show: 'true'
          },
          component: PlantManagement
        },
        {
          path: 'addPlant',
          name: 'xinzengdianzhan',
          meta: {
            title: 'addPowerStation',
            icon: 'iconfont icon-dianzhangaikuang',
            permission: 'pile.station.add',
            father:'powerStationManagement',
          },
          component: AddPlant
        },
        {
          path: 'revisePlant',
          name: 'xiugaidianzhan',
          meta: {
            title: 'editPowerStation',
            icon: 'iconfont icon-dianzhangaikuang',
            permission: 'pile.station.update',
            father:'powerStationManagement',
          },
          component: RevisePlant
        },
        {
          path: 'plantDetail',
          name: 'dianzhanxiangqing',
          meta: {
            title: 'powerStationDetails',
            icon: 'iconfont icon-dianzhangaikuang',
            permission: 'pile.station.details',
            father:'powerStationManagement',
          },
          component: PlantDetail
        },
        {
          path: 'plantRobot',
          name: 'dianzhanzhoubianshebei',
          meta: {
            title: 'plantRobot',
            icon: 'iconfont icon-dianzhangaikuang',
            permission: 'pile.station.details',
            father:'powerStationManagement',
          },
          component: PlantRobot
        },
        {
          path: 'pileManagement',
          name: 'dianzhuangguanli',
          meta: {
            title: 'electricPileManagement',
            icon: 'iconfont icon-chongdianzhuang',
            permission: 'pile.equipment',
            show: 'true'
          },
          component: PileManagement
        },
        {
          path: 'addPile',
          name: 'xinzengdianzhuang',
          meta: {
            title: 'addElectricPile',
            icon: 'iconfont icon-chongdianzhuang',
            permission: 'pile.equipment.add',
            father:'electricPileManagement'
          },
          component: AddPile
        },
        {
          path: 'chargingPile',
          name: 'xiugaichongdianqiang',
          meta: {
            title: 'editChargingGun',
            icon: 'iconfont icon-chongdianzhuang',
            permission: 'pile.equipment.update',
            father:'electricPileManagement'
          },
          component: ChargingPile
        },
        {
          path: 'pileDetail',
          name: 'chongdianqiangxiangqing',
          meta: {
            title: 'chargingGunDetails',
            icon: 'iconfont icon-chongdianzhuang',
            permission: 'pile.equipment.details',
            father:'electricPileManagement'
          },
          component: PileDetail
        },
        {
          path: 'whiteList',
          name: 'baimingdan',
          meta: {
            title: 'whiteList',
            icon: 'iconfont icon-chongdianzhuang',
            permission: 'pile.whiteList',
            show: 'true'
          },
          component: WhiteList
        },
        {
          path: 'addWhiteList',
          name: 'xinzengbaimingdan',
          meta: {
            title: 'addWhiteList',
            icon: 'iconfont icon-chongdianzhuang',
            permission: 'pile.whiteList.add'
          },
          component: AddWhiteList
        },
        {
          path: 'reviseWhiteList',
          name: 'xiugaibaimingdan',
          meta: {
            title: 'editWhiteList',
            icon: 'iconfont icon-chongdianzhuang',
            permission: 'pile.whiteList.update'
          },
          component: ReviseWhiteList
        },
        {
          path: 'whiteListDetail',
          name: 'baimingdanxiangqing',
          meta: {
            title: 'whiteListDetails',
            icon: 'iconfont icon-chongdianzhuang',
            permission: 'pile.whiteList.details'
          },
          component: WhiteListDetail
        },
        {
          path: 'plantcomment',
          name: 'zhandianpinglun',
          meta: {
            title: 'siteComment',
            icon: 'iconfont icon-pinglun',
            permission: 'comment',
            show: 'true'
          },
          component: PlantComment
        }
      ]
    },
    {
      path: '/flowScheme',
      name: 'flowScheme',
      meta: {
        title: 'interProgramme',
        icon: 'iconfont icon-lirunbiao',
        permission: 'valueadd'
      },
      component: Home,
      children: [
        {
          path: 'entranceScheme',
          name: 'rukoufangan',
          meta: {
            title: 'entranceScheme',
            icon: 'iconfont icon-chongdianzhuang',
            permission: 'valueadd.entrance',
            show: 'true'
          },
          component: EntranceScheme
        },
        {
          path: 'addEntrance',
          name: 'xinzengrukoufangan',
          meta: {
            title: 'addEntranceScheme',
            icon: '',
            permission: 'valueadd.entrance.add'
          },
          component: AddEntrance
        },
        {
          path: 'entranceDetail',
          name: 'rukoufanganxiangqing',
          meta: {
            title: 'entranceSchemeDetails',
            icon: '',
            permission: 'valueadd.entrance.details'
          },
          component: EntranceDetail
        },
        {
          path: 'reviseEntrance',
          name: 'rukoufanganxiugai',
          meta: {
            title: 'entranceSchemeEdit',
            icon: '',
            permission: 'valueadd.entrance.update'
          },
          component: ReviseEntrance
        },
        {
          path: 'flowScheme',
          name: 'liuliangfangan',
          meta: {
            title: 'flowScheme',
            icon: 'iconfont icon-chongdianzhuang',
            permission: 'valueadd.flow',
            show: 'true'
          },
          component: FlowScheme
        },
        {
          path: 'addFlowScheme',
          name: 'xinzengliuliangfangan',
          meta: {
            title: 'addFlowScheme',
            icon: 'iconfont icon-chongdianzhuang',
            permission: 'valueadd.flow.add'
          },
          component: AddFlowScheme
        },
        {
          path: 'flowSchemeDetail',
          name: 'liuliangfanganxiangqing',
          meta: {
            title: 'details',
            icon: 'iconfont icon-chongdianzhuang',
            permission: 'valueadd.flow.details'
          },
          component: FlowSchemeDetail
        },
        {
          path: 'reviseFlowScheme',
          name: 'liuliangfanganxiugai',
          meta: {
            title: 'flowSchemeEdit',
            icon: '',
            permission: 'valueadd.flow.update'
          },
          component: ReviseFlowScheme
        },
        {
          path: 'InterconnectedStation',
          name: 'hulianhutongdianzhan',
          meta: {
            title: 'interconnectedPowerStation',
            icon: 'iconfont icon-chongdianzhuang',
            permission: 'valueadd.interconnection',
            show: 'true'
          },
          component: InterconnectedStation
        },
        {
          path: 'InterConStationDetail',
          name: 'hulianhutongdianzhanxiangqing',
          meta: {
            title: 'InterConStationDetail',
            icon: '',
            permission: 'valueadd.interconnection.details'
          },
          component: InterConStationDetail
        },
        {
          path: 'reviseInterConStation',
          name: 'hulianhutongdianzhanxiugai',
          meta: {
            title: 'modify',
            icon: '',
            permission: 'valueadd.interconnection.details'
          },
          component: ReviseInterConStation
        },
        {
          path: 'InterConPileDetail',
          name: 'hulianhutongdianzhuangxiangqing',
          meta: {
            title: 'details',
            icon: 'iconfont icon-chongdianzhuang',
            permission: 'valueadd.key.details'
          },
          component: InterConPileDetail
        },
        {
          path: 'secretKeymanagement',
          name: 'hulianhutongmiyao',
          meta: {
            title: 'interconnectionKey',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'valueadd.key',
            show: 'true'
          },
          component: SecretKeymanagement
        },
        {
          path: 'addSecretKey',
          name: 'xinzengmiyao',
          meta: {
            title: 'newlyAdded',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'valueadd.key.add'
          },
          component: AddSecretKey
        },
        {
          path: 'secretKeyDetail',
          name: 'miyaoxiangqing',
          meta: {
            title: 'secretKeydetails',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'valueadd.key.details'
          },
          component: SecretKeyDetail
        },
        {
          path: 'reviseSecretKey',
          name: 'miyaoxiugai',
          meta: {
            title: 'modify',
            icon: '',
            permission: 'valueadd.key.update'
          },
          component: ReviseSecretKey
        },
        {
          path: 'gatemanagement',
          name: 'daozhaguanli',
          meta: {
            title: 'gateManagement',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'valueadd.gate.management',
            show: 'true'
          },
          component: GateManagement
        },
        {
          path: 'gateDetail',
          name: 'daozhaxiangqing',
          meta: {
            title: 'gateDetail',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'valueadd.gate.management.details'
          },
          component: GateDetail
        },
        {
          path: 'addGate',
          name: 'xinzengdaozha',
          meta: {
            title: 'daozhaadd',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'valueadd.gate.management.add'
          },
          component: AddGate
        },
        {
          path: 'reviseGate',
          name: 'xiugaidaozha',
          meta: {
            title: 'reviseGate',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'valueadd.gate.management.update'
          },
          component: ReviseGate
        }
      ]
    },
    {
      path: '/organManagement',
      name: 'organManagement',
      meta: {
        title: 'operatorManagement',
        icon: 'iconfont icon-qiyeyonghuguanli',
        permission: 'business'
      },
      component: Home,
      children: [
        {
          path: 'operatormanagement',
          name: 'qiyeguanli',
          meta: {
            title: 'operatorManagement',
            icon: 'iconfont icon-yunyingshang',
            permission: 'business.enterprise',
            show: 'true'
          },
          component: OperatorManagement
        },
        {
          path: 'addOperatormanagement',
          name: 'xinzengqiye',
          meta: {
            title: 'addOperatormanagement',
            icon: 'iconfont icon-user-cp-menu',
            permission: 'business.enterprise.add'
          },
          component: AddOperatormanagement
        },
        {
          path: 'modifyOperatormanagement',
          name: 'xiugaiqiye',
          meta: {
            title: 'modifyOperatormanagement',
            icon: 'iconfont icon-user-cp-menu',
            permission: 'business.enterprise.update'
          },
          component: ModifyOperatormanagement
        },
        {
          path: 'operatorDetail',
          name: 'qiyexiangqing',
          meta: {
            title: 'details',
            icon: 'iconfont icon-user-cp-menu',
            permission: 'business.enterprise.details'
          },
          component: OperatorDetail
        },
        {
          path: 'operatorWallet',
          name: 'qiyeqianbao',
          meta: {
            title: 'operatorWallet',
            icon: 'iconfont icon-user-cp-menu',
            permission: 'business.enterprise.corporate wallet'
          },
          component: OperatorWallet
        }
      ]
    },
    {
      path: '/orderManagement',
      name: 'orderManagement',
      meta: {
        title: 'orderManagement',
        icon: 'iconfont icon-jigouguanli',
        permission: 'order'
      },
      component: Home,
      children: [
        {
          path: 'ordermanagement',
          name: 'shishidingdan',
          meta: {
            title: 'userRealTimeOrder',
            icon: 'iconfont icon-dingdan',
            permission: 'order.userrealtime',
            show: 'true'
          },
          component: OrderManagement
        },
        {
          path: 'orderDetail',
          name: 'shishidingdanxiangqing',
          meta: {
            title: 'realTimeOrderDetails',
            icon: 'iconfont icon-dingdan',
            permission: 'order.userrealtime.details'
          },
          component: OrderDetail
        },
        {
          path: 'orderStationmanagement',
          name: 'shishidianzhandingdan',
          meta: {
            title: 'orderStationManagement',
            icon: 'iconfont icon-dingdan',
            permission: 'order.stationrealtime',
            show: 'true'
          },
          component: OrderStationmanagement
        },
        {
          path: 'orderStationmanagementDetail',
          name: 'shishidingdanxiangqing',
          meta: {
            title: 'orderStationmanagementDetail',
            icon: 'iconfont icon-dingdan',
            permission: 'order.userrealtime.details'
          },
          component: OrderDetail
        },
        {
          path: 'historymanagement',
          name: 'yonghulishidingdan',
          meta: {
            title: 'userHistoryOrder',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'order.userhistory',
            show: 'true'
          },
          component: Historymanagement
        },
        {
          path: 'historyDetail',
          name: 'yonghulishidingdanxiangqing',
          meta: {
            title: 'historyOrderDetails',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'order.userhistory.details'
          },
          component: HistoryDetail
        },
        {
          path: 'historyDetaill',
          name: 'yonghulishidingdanxiangqing',
          meta: {
            title: 'historyStationDetail',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'order.userhistory.details'
          },
          component: HistoryDetail
        },
        {
          path: 'historyStationmanagement',
          name: 'dianzhanlishidingdan',
          meta: {
            title: 'stationHistoryOrder',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'order.stationhistory',
            show: 'true'
          },
          component: HistoryStationmanagement
        },
        {
          path: 'historyStationDetail',
          name: 'yonghulishidingdanxiangqing',
          meta: {
            title: 'historyStationDetail',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'order.userhistory.details'
          },
          component: HistoryDetail
        },
        {
          path: 'occupyDetail',
          name: 'zhanyongjiluxiangqing',
          meta: {
            title: 'occupyDetail',
            icon: '',
            permission: 'order.stationhistory'
          },
          component: occupyDetail
        },
        {
          path: 'pendingOrders',
          name: 'daichulidingdan',
          meta: {
            title: 'pendingOrders',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'order.pending',
            show: 'true'
          },
          component: PendingOrders
        },
        {
          path: 'pendingDetail',
          name: 'daichulidingdanxiangqing',
          meta: {
            title: 'details',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'order.pending.details'
          },
          component: PendingDetail
        },
        {
          path: 'processingPending',
          name: 'daichulidingdanchuli',
          meta: {
            title: 'daichulidingdanchuli',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'order.pending.handle'
          },
          component: ProcessingPending
        }
      ]
    },
    {
      path: '/activityManagement',
      name: 'activityManagement',
      meta: {
        title: 'userActivity',
        icon: 'iconfont icon-jigouguanli',
        permission: 'activity'
      },
      component: Home,
      children: [
        {
          path: 'registrationActivities',
          name: 'zhucehuodong',
          meta: {
            title: 'registrationActivities',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.registration.activity',
            show: 'true'
          },
          component: RegistrationActivities
        },
        {
          path: 'registrationAdd',
          name: 'zhucehuodongxinzeng',
          meta: {
            title: 'registrationAdd',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.registration.activity.add'
          },
          component: RegistrationAdd
        },
        {
          path: 'registrationModify',
          name: 'zhucehuodongxiugai',
          meta: {
            title: 'registrationModify',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.registration.activity.update'
          },
          component: RegistrationModify
        },
        {
          path: 'firstCharge',
          name: 'shoucichongdianhuodong',
          meta: {
            title: 'firstCharge',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.firstCharge',
            show: 'true'
          },
          component: firstCharge
        },
        {
          path: 'firstAdd',
          name: 'shoucichongdianxinzeng',
          meta: {
            title: 'firstAdd',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.firstCharge.add'
          },
          component: firstAdd
        },
        {
          path: 'firstModify',
          name: 'shoucichongdianxiugai',
          meta: {
            title: 'firstModify',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.firstCharge.update'
          },
          component: firstModify
        },
        {
          path: 'firstDetail',
          name: 'shoucichongdianxiugai',
          meta: {
            title: 'firstDetail',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.firstCharge.update'
          },
          component: firstDetail
        },
        {
          path: 'rechargeActivities',
          name: 'chongzhihuodong',
          meta: {
            title: 'rechargeActivities',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.activity.recharge',
            show: 'true'
          },
          component: RechargeActivities
        },
        {
          path: 'rechargeAdd',
          name: 'chongzhihuodongxinzeng',
          meta: {
            title: 'rechargeAdd',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.activity.recharge.add'
          },
          component: RechargeAdd
        },
        {
          path: 'rechargeModify',
          name: 'chongzhihuodongxiugai',
          meta: {
            title: 'rechargeModify',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.activity.recharge.update'
          },
          component: RechargeModify
        },
        {
          path: 'rechargeDetail',
          name: 'rechargeDetail',
          meta: {
            title: 'rechargeDetail',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.activity.recharge.details'
          },
          component: RechargeDetail
        },
        {
          path: 'singleConsumption',
          name: 'dancixiaofeihuodong',
          meta: {
            title: 'singleConsumption',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.single.consumption.activity',
            show: 'true'
          },
          component: SingleConsumption
        },
        {
          path: 'singleAdd',
          name: 'dancixiaofeihuodongxinzeng',
          meta: {
            title: 'singleAdd',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.single.consumption.activity.add'
          },
          component: SingleAdd
        },
        {
          path: 'singleModify',
          name: 'dancixiaofeihuodongxiugai',
          meta: {
            title: 'singleModify',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.single.consumption.activity.update'
          },
          component: SingleModify
        },
        {
          path: 'singleDetail',
          name: 'singleDetail',
          meta: {
            title: 'singleDetail',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.single.consumption.activity.details'
          },
          component: SingleDetail
        },
        {
          path: 'cumulativeConsumption',
          name: 'leijixiaofeihuodong',
          meta: {
            title: 'cumulativeConsumption',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.cumulative.consumption.activity',
            show: 'true'
          },
          component: CumulativeConsumption
        },
        {
          path: 'cumulativeAdd',
          name: 'leijixiaofeihuodongxinzeng',
          meta: {
            title: 'cumulativeAdd',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.cumulative.consumption.activity.add'
          },
          component: CumulativeAdd
        },
        {
          path: 'cumulativeModify',
          name: 'leijixiaofeihuodongxiugai',
          meta: {
            title: 'cumulativeModify',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.cumulative.consumption.activity.update'
          },
          component: CumulativeModify
        },
        {
          path: 'cumulativeDetail',
          name: 'cumulativeDetail',
          meta: {
            title: 'cumulativeDetail',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.cumulative.consumption.activity.details'
          },
          component: CumulativeDetail
        },
        {
          path: 'shareActivity',
          name: 'fenxianghuodong',
          meta: {
            title: 'shareActivity',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.sharing.activities',
            show: 'true'
          },
          component: ShareActivity
        },
        {
          path: 'shareAdd',
          name: 'fenxianghuodongxinzeng',
          meta: {
            title: 'shareAdd',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.sharing.activities.add'
          },
          component: ShareAdd
        },
        {
          path: 'shareModify',
          name: 'fenxianghuodongxiugai',
          meta: {
            title: 'shareModify',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.sharing.activities.update'
          },
          component: ShareModify
        },
        {
          path: 'shareDetail',
          name: 'fenxianghuodongxiugai',
          meta: {
            title: 'shareDetail',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.sharing.activities.details'
          },
          component: ShareDetail
        },
        {
          path: 'groupCharge',
          name: 'zutuanchongdianhuodong',
          meta: {
            title: 'groupCharge',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.groupCharging',
            show: 'true'
          },
          component: groupCharge
        },
        {
          path: 'groupAdd',
          name: 'zutuanchongdianxinzeng',
          meta: {
            title: 'groupAdd',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.groupCharging.add'
          },
          component: groupAdd
        },
        {
          path: 'groupModify',
          name: 'zutuanchongdianxiugai',
          meta: {
            title: 'groupModify',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.groupCharging.update'
          },
          component: groupModify
        },
        {
          path: 'groupDetail',
          name: 'groupDetail',
          meta: {
            title: 'groupDetail',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.groupCharging.details'
          },
          component: groupDetail
        },
        // {
        //   path: 'scanGet',
        //   name: 'saomalingquanhuodong',
        //   meta: {
        //     title: 'scanGet',
        //     icon: 'iconfont icon-dingdan',
        //     permission: 'activity.scanningCoupon',
        //     show: 'true'
        //   },
        //   component: scanGet
        // },
        {
          path: 'scanAdd',
          name: 'saomaxinzeng',
          meta: {
            title: 'scanAdd',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.scanningCoupon.add'
          },
          component: scanAdd
        },
        {
          path: 'scanModify',
          name: 'modify',
          meta: {
            title: 'scanModify',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.scanningCoupon.update'
          },
          component: scanModify
        },
        {
          path: 'scanDetail',
          name: 'scanDetail',
          meta: {
            title: 'scanDetail',
            icon: 'iconfont icon-dingdan',
            permission: 'activity.scanningCoupon.update'
          },
          component: scanDetail
        }
      ]
    },
    {
      path: '/couponManagement',
      name: 'couponManagement',
      meta: {
        title: 'couponManagement',
        icon: 'iconfont icon-youhui',
        permission: 'coupons'
      },
      component: Home,
      children: [
        {
          path: 'CouponManager',
          name: 'youhuiquanguanli',
          meta: {
            title: 'coupon',
            icon: 'iconfont icon-youhui',
            permission: 'coupons.manage',
            show: 'true'
          },
          component: CouponManager
        },
        {
          path: 'couponManagerAdd',
          name: 'youhuiquanxinzeng',
          meta: {
            title: 'couponManagerAdd',
            icon: 'iconfont icon-youhui',
            permission: 'coupons.manage.add'
          },
          component: CouponManagerAdd
        },
        {
          path: 'couponDetail',
          name: 'youhuiquanxiangqing',
          meta: {
            title: 'couponDetail',
            icon: 'iconfont icon-youhui',
            permission: 'coupons.manage.hand.out'
          },
          component: CouponDetail
        },
        {
          path: 'couponIssuance',
          name: 'youhuiquanfafang',
          meta: {
            title: 'couponIssuance',
            icon: 'iconfont icon-youhui',
            permission: 'coupons.manage.grant'
          },
          component: CouponIssuance
        },
        {
          path: 'couponIssuanceDetails',
          name: 'youhuiquanfafangmingxi',
          meta: {
            title: 'couponIssuanceDetails',
            icon: 'iconfont icon-youhui',
            permission: 'coupons.manage.release.details'
          },
          component: CouponIssuanceDetails
        },
        {
          path: 'ManualRelease',
          name: 'shoudongfafangjilu',
          meta: {
            title: 'manualRelease',
            icon: 'iconfont icon-youhui',
            permission: 'coupons.manual.release.record',
            show: 'true'
          },
          component: ManualRelease
        },
        {
          path: 'ManualReleaseUpdate',
          name: 'ManualReleaseUpdate',
          meta: {
            title: 'ManualReleaseUpdate',
            icon: 'iconfont icon-youhui',
            permission: 'coupons.manual.release.record.update',
          },
          component: ManualReleaseUpdate
        },
        {
          path: 'ManualReleaseDetail',
          name: 'ManualReleaseDetail',
          meta: {
            title: 'ManualReleaseDetail',
            icon: 'iconfont icon-youhui',
            permission: 'coupons.manual.release.record.details',
          },
          component: ManualReleaseDetail
        },
      ]
    },
    {
      path: '/informManagement',
      name: 'tongzhiguanli',
      meta: {
        title: 'notificationManagement',
        icon: 'iconfont icon-tongzhi',
        permission: 'notice'
      },
      component: Home,
      children: [
        {
          path: 'informmanagement',
          name: 'tongzhiguanli',
          meta: {
            title: 'messageSending',
            icon: 'iconfont icon-tongzhi',
            permission: 'notice.news',
            show: 'true'
          },
          component: InformManagement
        },
        {
          path: 'addInformManagement',
          name: 'xinzengxiaoxi',
          meta: {
            title: 'addInformManagement',
            icon: 'iconfont icon-tongzhi',
            permission: 'notice.news.add'
          },
          component: AddInformManagement
        },
        {
          path: 'informDetail',
          name: 'xiaoxixiangqing',
          meta: {
            title: 'informDetail',
            icon: 'iconfont icon-tongzhi',
            permission: 'notice.news.details'
          },
          component: InformDetail
        },
        {
          path: 'reviseInform',
          name: 'xiugaixiaoxi',
          meta: {
            title: 'reviseInform',
            icon: 'iconfont icon-tongzhi',
            permission: 'notice.news.update'
          },
          component: ReviseInform
        },
        {
          path: 'smsSettings',
          name: 'duanxinshezhi',
          meta: {
            title: 'smsSettings',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'notice.message',
            show: 'true'
          },
          component: SmsSettings
        }
      ]
    },
    {
      path: '/adManagement',
      name: 'guanggaoguanli',
      meta: {
        title: 'advertisingManagement',
        icon: 'iconfont icon-guanggao',
        permission: 'advertisement'
      },
      component: Home,
      children: [
        {
          path: 'admanagement',
          name: 'guanggaoguanli',
          meta: {
            title: 'advertisingManagement',
            icon: 'iconfont icon-guanggao',
            permission: 'advertisement',
            show: 'true'
          },
          component: AdManagement
        },
        {
          path: 'addAd',
          name: 'xinzengguanggao',
          meta: {
            title: 'addAd',
            icon: 'iconfont icon-guanggao',
            permission: 'advertisement.add'
          },
          component: AddAd
        },
        {
          path: 'reviseAd',
          name: 'xiugaiguanggao',
          meta: {
            title: 'reviseAd',
            icon: 'iconfont icon-guanggao',
            permission: 'advertisement.update'
          },
          component: ReviseAd
        }
      ]
    },
    {
      path: '/discount',
      name: 'dianzhanhuodong',
      meta: {
        title: 'powerStationActivities',
        icon: 'iconfont icon-youhui',
        permission: 'station.activity'
      },
      component: Home,
      children: [
        {
          path: 'discount',
          name: 'youhuifangan',
          meta: {
            title: 'preferentialScheme',
            icon: 'iconfont icon-youhui',
            permission: 'station.activity.discount',
            show: 'true'
          },
          component: Discount
        },
        {
          path: 'addDiscount',
          name: 'xinzengyouhuifangan',
          meta: {
            title: 'addPreferentialScheme',
            icon: 'iconfont icon-youhui',
            permission: 'station.activity.discount.add'
          },
          component: AddDiscount
        },
        {
          path: 'discountDetail',
          name: 'youhuifanganxiangqing',
          meta: {
            title: 'preferentialSchemeDetails',
            icon: 'iconfont icon-youhui',
            permission: 'station.activity.discount.details'
          },
          component: DiscountDetail
        },
        {
          path: 'reviseDiscount',
          name: 'xiugaiyouhuifangan',
          meta: {
            title: 'editPreferentialScheme',
            icon: 'iconfont icon-youhui',
            permission: 'station.activity.discount.update'
          },
          component: ReviseDiscount
        }
      ]
    },
    {
      path: '/alarmManagement',
      name: 'gaojingzhongxin',
      meta: {
        title: 'alarmCenter',
        icon: 'iconfont icon-icon-',
        permission: 'alarm'
      },
      component: Home,
      children: [
        {
          path: 'pileSafetyAlarm',
          name: 'dianzhuanganquangaojing',
          meta: {
            title: 'pileSafetyAlarm',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.equipment',
            show: 'true'
          },
          component: PileSafetyAlarm
        },
        {
          path: 'pileSafetyAlarmDetail',
          name: 'dianzhuanganquangaojingxiangqing',
          meta: {
            title: 'pileSafetyAlarmDetails',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.equipment.charge.details'
          },
          component: PileSafetyAlarmDetail
        },
        {
          path: 'pileOffLineAlarmDetail',
          name: 'dianzhuanglixiangaojingxiangqing',
          meta: {
            title: 'pileOfflineAlarmDetails',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.equipment.offline.details'
          },
          component: PileOffLineAlarmDetail
        },
        {
          path: 'pileFaultAlarmDetail',
          name: 'dianzhuangguzhanggaojingxiangqing',
          meta: {
            title: 'pileFaultAlarmDetails',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.equipment.fault.details'
          },
          component: PileFaultAlarmDetail
        },
        {
          path: 'vehicleAlarm',
          name: 'chelianggaojing',
          meta: {
            title: 'vehicleAlarm',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.car',
            show: 'true'
          },
          component: VehicleAlarm
        },
        {
          path: 'vehicleAlarmDetail',
          name: 'chelianggaojingxiangqing',
          meta: {
            title: 'vehicleAlarmDetails',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.car.details'
          },
          component: VehicleAlarmDetail
        },
        {
          path: 'negativeValueAlarm',
          name: 'zhanghufuzhigaojing',
          meta: {
            title: 'negativeValueAlarm',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.negative',
            show: 'true'
          },
          component: NegativeValueAlarm
        },
        {
          path: 'stationAlarmSetting',
          name: 'gaojingshezhi',
          meta: {
            title: 'stationAlarmSetting',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.deploy',
            show: 'true'
          },
          component: StationAlarmSetting
        },
        {
          path: 'addAlarmSetting',
          name: 'xinzenggaojingshezhi',
          meta: {
            title: 'addAlarmSetting',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.deploy.add'
          },
          component: AddAlarmSetting
        },
        {
          path: 'reviseAlarmSetting',
          name: 'xiugaigaojingshezhi',
          meta: {
            title: 'editAlarmSetting',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.deploy.update'
          },
          component: ReviseAlarmSetting
        },
        {
          path: 'alarmSettingDetail',
          name: 'gaojingshezhixiangqing',
          meta: {
            title: 'alarmSettingDetails',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.deploy.details'
          },
          component: AlarmSettingDetail
        },
        {
          path: 'groupManagement',
          name: 'gaojingtongzhizuguanli',
          meta: {
            title: 'groupManagement',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.group',
            show: 'true'
          },
          component: GroupManagement
        },
        {
          path: 'alarmNotificationRecord',
          name: 'gaojingtongzhijilu',
          meta: {
            title: 'alarmRecord',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.record',
            show: 'true'
          },
          component: AlarmNotificationRecord
        },
        {
          path: 'keshidaRecord',
          name: 'gaojingtongzhijilu',
          meta: {
            title: 'keshidaRecord',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.ksd',
            show: 'true'
          },
          component: KeshidaRecord
        },
        {
          path: 'addGroupManagement',
          name: 'xinzenggaojingtongzhizu',
          meta: {
            title: 'addGroupManagement',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.group.add'
          },
          component: AddGroupManagement
        },
        {
          path: 'reviseGroup',
          name: 'xiugaigaojingtongzhizu',
          meta: {
            title: 'reviseGroup',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.group.update'
          },
          component: ReviseGroup
        },
        {
          path: 'groupManagementDetail',
          name: 'gaojingtongzhizuxiangqing',
          meta: {
            title: 'groupManagementDetail',
            icon: 'iconfont icon-icon-',
            permission: 'alarm.group.details'
          },
          component: GroupManagementDetail
        }
      ]
    },
    {
      path: '/statistics',
      name: 'tongjizhongxin',
      meta: {
        title: 'statisticalCenter',
        icon: 'iconfont icon-icon-',
        permission: 'statistics'
      },
      component: Home,
      children: [
        {
          path: 'stationTotal',
          name: 'dianzhangtongji',
          meta: {
            title: 'stationTotal',
            icon: 'iconfont icon-tongjizhongxin',
            permission: 'statistics.station',
            show: 'true'
          },
          component: StationTotal
        },
        {
          path: 'pileTotal',
          name: 'zhongduantongji',
          meta: {
            title: 'pileTotal',
            icon: 'iconfont icon-tongjizhongxin',
            permission: 'statistics.gun',
            show: 'true'
          },
          component: PileTotal
        }, //
        {
          path: 'organTotal',
          name: 'cheliangjigoutongji',
          meta: {
            title: 'organTotal',
            icon: 'iconfont icon-tongjizhongxin',
            permission: 'statistics.organization',
            show: 'true'
          },
          component: OrganTotal
        },
        {
          path: 'userTotal',
          name: 'yonghutongji',
          meta: {
            title: 'userTotal',
            icon: 'iconfont icon-tongjizhongxin',
            permission: 'statistics.account',
            show: 'true'
          },
          component: UserTotal
        },
        {
          path: 'timeUserTotal',
          name: 'yonghushiqitongji',
          meta: {
            title: 'timeUserTotal',
            icon: 'iconfont icon-tongjizhongxin',
            permission: 'statistics.accountperiod',
            show: 'true'
          },
          component: TimeUserTotal
        },
        {
          path: 'timeStationTotal',
          name: 'dianzhanshiqitongji',
          meta: {
            title: 'timeStationTotal',
            icon: 'iconfont icon-tongjizhongxin',
            permission: 'statistics.stationperiod',
            show: 'true'
          },
          component: TimeStationTotal
        },
        {
          path: 'pileUse',
          name: 'dianzhuangshiyongtongji',
          meta: {
            title: 'pileUse',
            icon: 'iconfont icon-tongjizhongxin',
            permission: 'electric.pile.usage.statistics',
            show: 'true'
          },
          component: PileUse
        },
        {
          path: 'pileFault',
          name: 'dianzhuangguzhangtongji',
          meta: {
            title: 'pileFault',
            icon: 'iconfont icon-tongjizhongxin',
            permission: 'electric.pile.fault.statistics',
            show: 'true'
          },
          component: PileFault
        },
        {
          path: 'pileFaultList',
          name: 'dianzhuangpinpailiebiao',
          meta: {
            title: 'pileFaultList',
            icon: 'iconfont icon-icon-',
            permission: 'electric.pile.fault.statistics'
          },
          component: PileFaultList
        }
        // {
        //   path:"brandTotal",
        //   name:"pingpaiguzhangtongji",
        //   meta:{
        //     title:"品牌故障统计",
        //     icon:"iconfont icon-tongjizhongxin",
        //     permission:"statistics",
        //     show: "true",
        //   },
        //   component:BrandTotal
        // },
        // {
        //   path:"typeTotal",
        //   name:"xinghaoguzhangtongji",
        //   meta:{
        //     title:"型号故障统计",
        //     icon:"iconfont icon-tongjizhongxin",
        //     permission:"statistics",
        //     // show: "true",
        //   },
        //   component:TypeTotal
        // },
        // {
        //   path:"statusTotal",
        //   name:"dianzhuangzhuangtaitongji",
        //   meta:{
        //     title:"电桩状态统计",
        //     icon:"iconfont icon-tongjizhongxin",
        //     permission:"statistics",
        //     show: "true",
        //   },
        //   component:StatusTotal
        // }
      ]
    },
    {
      path: '/ticketManagement',
      name: 'ticketManagement',
      meta: {
        title: 'financialManagement',
        icon: 'iconfont icon-piaowu',
        permission: 'finance'
      },
      component: Home,
      children: [
        {
          path: 'summaryFinancial',
          name: 'caiwugaikuang',
          meta: {
            title: 'financialOverview',
            icon: 'iconfont icon-piaowu',
            permission: 'finance.survey',
            show: 'true'
          },
          component: SummaryFinancial
        },
        {
          path: 'moneyCount',
          name: 'fenrunhuizong',
          meta: {
            title: 'moneyCount',
            icon: 'iconfont icon-piaowu',
            permission: 'finance.survey',
            show: 'true'
          },
          component: moneyCount
        },
        {
          path: 'earnMoney',
          name: 'fenrunjinechakan',
          meta: {
            title: 'earnMoney',
            icon: 'iconfont icon-piaowu',
            permission: 'finance.survey',
            show: 'true'
          },
          component: earnMoney
        },
        {
          path: 'profitRecord',
          name: 'fenrunjilu',
          meta: {
            title: 'profitRecord',
            icon: 'iconfont icon-piaowu',
            permission: 'finance.profitRecord',
            show: 'true'
          },
          component: profitRecord
        },
        {
          path: 'profitSettle',
          name: 'fenrunjilujiesuan',
          meta: {
            title: 'profitSettle',
            icon: 'iconfont icon-piaowu',
            permission: 'finance.profitRecord',
            show: 'true'
          },
          component: profitSettle
        },
        {
          path: 'moneyDetail',
          name: 'fenrunmingxi',
          meta: {
            title: 'moneyDetail',
            icon: '',
            permission: ''
          },
          component: moneyDetail
        },
        {
          path: 'payDetail',
          name: 'dingdanmingxi',
          meta: {
            title: 'payDetail',
            icon: '',
            permission: ''
          },
          component: payDetail
        },
        {
          path: 'summaryDetailFinancial',
          name: 'caiwumingxin',
          meta: {
            title: 'financialDetails',
            icon: 'iconfont icon-piaowu',
            permission: ''
          },
          component: SummaryDetailFinancial
        },
        {
          path: 'orderDetail',
          name: 'dingdanxiangqing',
          meta: {
            title: 'orderDetail',
            icon: '',
            permission: ''
          },
          component: OrderDetailSummary
        },
        {
          path: 'carDetail',
          name: 'cheliangjigoumingxi',
          meta: {
            title: 'financialDetails',
            icon: 'iconfont icon-piaowu',
            permission: ''
          },
          component: CarDetail
        },
        {
          path: 'flowDetail',
          name: 'liuliangfangmingxi',
          meta: {
            title: 'financialDetails',
            icon: 'iconfont icon-piaowu',
            permission: ''
          },
          component: FlowDetail
        },
        {
          path: 'ticketmanagement',
          name: 'piaowuguanli',
          meta: {
            title: 'ticketManagement',
            icon: 'iconfont icon-piaowu',
            permission: 'finance.ticketing',
            show: 'true'
          },
          component: TicketManagement
        },
        {
          path: 'ticketModification',
          name: 'piaowuxiugai',
          meta: {
            title: 'ticketEdit',
            icon: 'iconfont icon-piaowu',
            permission: 'finance.ticketing.update'
          },
          component: TicketModification
        },
        {
          path: 'invoiceApproval',
          name: 'kaipiaoshenpi',
          meta: {
            title: 'invoicingApproval',
            icon: 'iconfont icon-piaowu',
            permission: 'finance.invoice',
            show: 'true'
          },
          component: InvoiceApproval
        },
        {
          path: 'invoiceDetail',
          name: 'kaipiaoxiangqing',
          meta: {
            title: 'invoicingDetails',
            icon: 'iconfont icon-piaowu',
            permission: 'finance.invoice.details'
          },
          component: InvoiceDetail
        }
      ]
    },
    {
      path: '/chargingCard',
      name: 'chargingCard',
      meta: {
        title: 'chargingCardManagement',
        icon: 'iconfont icon-piaowu',
        permission: 'card'
      },
      component: Home,
      children: [
        {
          path: 'chargingcard',
          name: 'chongdiankaguanli',
          meta: {
            title: 'chargingCardManagement',
            icon: 'iconfont icon-qia',
            permission: 'card',
            show: 'true'
          },
          component: ChargingCard
        },
        {
          path: 'ChargingCardModify',
          name: 'chongdiankaxiugai',
          meta: {
            title: 'chargingCardEdit',
            icon: 'iconfont icon-qia',
            permission: 'card.update'
          },
          component: ChargingCardModify
        }
      ]
    },
    // {
    //   path: '/monitorView',
    //   name: 'jiankongchakan',
    //   meta: {
    //     title: 'monitorView',
    //     icon: 'iconfont icon-quanxianguanli',
    //     permission: 'monitor'
    //   },
    //   component: Home,
    //   children: [
    //     {
    //       path: 'monitorView',
    //       name: 'jiankongchakan',
    //       meta: {
    //         title: 'monitorView',
    //         icon: 'iconfont icon-zhamenxinxi',
    //         permission: 'monitor',
    //         show: 'true'
    //       },
    //       component: MonitorView
    //     }
    //   ]
    // },
    {
      path: '/logView',
      name: 'rizhichakan',
      meta: {
        title: 'logView',
        icon: 'iconfont icon-quanxianguanli',
        permission: 'logCheck'
      },
      component: Home,
      children: [
        {
          path: 'logOperation',
          name: 'caozuorizhi',
          meta: {
            title: 'logOperation',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'logCheck.operationlog',
            show: 'true'
          },
          component: LogOperation
        },
        {
          path: 'logManagement',
          name: 'dianzhuangbaowen',
          meta: {
            title: 'logManagement',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'logCheck.electricPileMessageManagement',
            show: 'true'
          },
          component: LogManagement
        },
        {
          path: 'logDetail',
          name: 'baowenxiangqing',
          meta: {
            title: 'logDetail',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'logCheck.electricPileMessageManagement'
          },
          component: LogDetail
        }
      ]
    },
    {
      path: '/systemManagement',
      name: 'xitongguanli',
      meta: {
        title: 'systemManagement',
        icon: 'iconfont icon-quanxianguanli',
        permission: 'system'
      },
      component: Home,
      children: [
        {
          path: 'stationBrand',
          name: 'dianzhuangpinpaiguanli',
          meta: {
            title: 'stationBrand',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'system.electric.pile.brand.management',
            show: 'true'
          },
          component: StationBrand
        },
        {
          path: 'stationModel',
          name: 'dianzhuangxinghaoguanli',
          meta: {
            title: 'stationModel',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'system.electric.pile.type.management',
            show: 'true'
          },
          component: StationModel
        },
        {
          path: 'stationModelAdd',
          name: 'dianzhuangxinghaoguanlixinzeng',
          meta: {
            title: 'stationModelAdd',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'system.electric.pile.type.management.add'
          },
          component: StationModelAdd
        },
        {
          path: 'stationModelModify',
          name: 'dianzhuangxinghaoguanlixiugai',
          meta: {
            title: 'stationModelModify',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'system.electric.pile.type.management.update'
          },
          component: StationModelModify
        },
        {
          path: 'firmwareVersion',
          name: 'gujianbanbenguanli',
          meta: {
            title: 'firmwareVersion',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'system.electric.pile.type.management',
            show: 'true'
          },
          component: FirmwareVersion
        },
        {
          path: 'versionAdd',
          name: 'gujianbanbenxinzeng',
          meta: {
            title: 'versionAdd',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'system.electric.pile.type.management.add'
          },
          component: EditVersion
        },
        {
          path: 'versionModify',
          name: 'gujianbanbenxiugai',
          meta: {
            title: 'versionModify',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'system.electric.pile.type.management.update'
          },
          component: EditVersion
        },
        {
          path: 'nearRobot',
          name: 'zhoubianshebeiguanli',
          meta: {
            title: 'nearRobot',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'pile.peripheralequipmentmanagement',
            show: 'true'
          },
          component: NearRobot
        },
        {
          path: 'nearAdd',
          name: 'zhoubianshebeixinzeng',
          meta: {
            title: 'nearAdd',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'pile.peripheralequipmentmanagement.add'
          },
          component: NearModify
        },
        {
          path: 'nearModify',
          name: 'zhoubianshebeixinzeng',
          meta: {
            title: 'nearModify',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'pile.peripheralequipmentmanagement.update'
          },
          component: NearModify
        },
        // {
        //   path: 'appManagement',
        //   name: 'appguanli',
        //   meta: {
        //     title: 'appManagement',
        //     icon: 'iconfont icon-zhamenxinxi',
        //     permission: 'system.version',
        //     show: 'true'
        //   },
        //   component: AppManagement
        // },
        {
          path: 'systemSetting',
          name: 'xitongshezhi',
          meta: {
            title: 'systemSettings',
            icon: 'iconfont icon-zhamenxinxi',
            permission: 'system.deploy',
            show: 'true'
          },
          component: SystemSetting
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js